export const QUERY_KEY = "links";
